<template>
  <div>
    <br />
    <br />
    <div class="excel-input">
      <h2 style="color: #002856;">Bilddaten + Textdaten</h2>
      <br />
      <b-card-group deck>
        <b-card img-alt="Card image" img-src="./../assets/excel_pred.png" img-top>
          <b-card-text
            style="color: black;"
          >Man muss natürlich nicht nur Bilddaten oder nur Textdaten verwenden als Trainingsmenge. Die Vermutung liegt nahe, dass wir durch Kombination von Bild- und Textdaten ein besseres Modell erhalten als wenn wir nur eines von Beidem verwenden.</b-card-text>
        </b-card>
        <b-card img-alt="Card image">
          <b-card-text
            style="color: black;"
          >Hier können Sie eine Excel-Datei mit den Textdaten und der Bild-URL hochladen. Der Text in der Zeile wird für die Klassifizierung verwendet und die Bild-URL wird automatisch erkannt, um das Bild herunterzuladen und zu klassifizieren. Das Ergebnis der Excel-Datei wird am Ende im Browser heruntergeladen.</b-card-text>
          <br />
          <b-form-file
            type="file"
            id="file"
            ref="file"
            v-model="file"
            :state="Boolean(file)"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            placeholder="Excel-Datei auswählen oder Drag & Drop..."
            @change="handleFileUpload()"
          ></b-form-file>
          <div
            class="mt-3"
            style="color: grey; text-align: left;"
          >Selected file: {{file && file.name}}</div>
          <br />
          <button
            id="sub"
            type="button"
            class="btn btn-outline-success btn-lg"
            @click="submitFile()"
          >Senden</button>
          <br />
          <br />
          <template v-if="!showResultBars && buttonClicked">
            <b-spinner large type="grow" variant="success" label="Loading..." />
          </template>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import FileSaver from "file-saver";

export default {
  name: "ExcelPred",

  data() {
    return {
      showResultBars: false,
      file: "",
      filename: "",
      response: {},
      buttonClicked: false,
      apiBase: process.env.VUE_APP_ROOT_API,
      token: process.env.VUE_APP_API_TOKEN
    };
  },
  methods: {
    /*
        Submits the file to the server
    */
    submitFile() {
      if (this.file != "") {
        this.filename = this.file["name"].replace(/\.[^/.]+$/, "");
        let formData = new FormData();
        this.buttonClicked = true;
        formData.append("file", this.file);

        axios
          .post(this.apiBase + "/predict/excel/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: this.token
            },
            responseType: "blob",
            timeout: 5500000
          })
          .then(response => {
            console.log(response);
            if (response.status == 201) {
              console.log("SUCCESS!!");
              console.log(response.data);
              saveAs(response.data, this.filename + "_result.xlsx");
              this.buttonClicked = false;
              this.showResultBars = false;
            }
          })
          .catch(error => {
            console.log(error);
            this.buttonClicked = false;
            this.showResultBars = false;
            if (error.response != null && error.response.status == 413) {
              alert("Exceeded maximum of 5000 rows/30mb file");
            } else if (error.response != null && error.response.status == 408) {
              alert("Request timed out");
            } else {
              alert("An error has occured");
            }
          });
      } else {
        alert("Please upload an Excel file");
      }
    },
    handleFileUpload() {
      this.showResultBars = false;
      this.buttonClicked = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.excel-imput {
  margin: 100px 0 0px 0;
  padding: 5px 5px 0px 5px;
}
p {
  margin: 50px 0px 0px 0px;
}
#sub {
  color: #002856;
  border-color: #002856;
}
</style>
